import { render, staticRenderFns } from "./reward.vue?vue&type=template&id=494d9c65&scoped=true&"
import script from "./reward.vue?vue&type=script&lang=js&"
export * from "./reward.vue?vue&type=script&lang=js&"
import style0 from "./reward.vue?vue&type=style&index=0&lang=css&"
import style1 from "./reward.vue?vue&type=style&index=1&lang=less&"
import style2 from "./reward.vue?vue&type=style&index=2&id=494d9c65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d9c65",
  null
  
)

export default component.exports